import Image from 'components/Common/Image'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  overflow: hidden;
`

const Gradient = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
`

interface Props {
  imageId: string;
  backgroundStyle?: string;
  className?: string;
}

export function GenericBackgroundImage({ imageId, className, backgroundStyle }: Props) {
  const imageProps = {
    id: imageId,
    dpr: 2 as const,
    fit: 'center' as const,
  }
  return <Container className={className}>
    <Image {...imageProps} />
    {backgroundStyle && <Gradient style={{ background: backgroundStyle }} />}
  </Container>
}
